import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';

const DEMO_MOBILE_OTP = '123456';

const SignupMobile = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);

  const handleBack = () => {
    navigate('/admin');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (mobile.trim().length !== 10) {
      toast.error('Please enter a valid 10-digit mobile number');
      return;
    }

    setLoading(true);

    try {
      // TODO: Replace with actual API call
      // const response = await authServices.sendOtp(mobile.trim());

      // Simulating API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      toast.success('OTP sent successfully');

      // Navigate with state
      navigate('/signup/otp', {
        state: {
          mobile: mobile.trim(),
          demoOtp: DEMO_MOBILE_OTP
        }
      });
    } catch (error) {
      toast.error('Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Create account"
      subtitle="Enter your mobile number to start registration"
      onBack={handleBack}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Mobile Number</label>
          <input
            type="tel"
            className="form-input"
            maxLength={10}
            value={mobile}
            onChange={(event) => {
              const value = event.target.value.replace(/\D/g, '');
              setMobile(value);
            }}
            placeholder="Enter mobile number"
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Sending OTP...' : 'Send OTP'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupMobile;


